export default __webpack_public_path__ + "59f905155c3e8d62bb3bf7986b3c0e3b.woff2";